import React, { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import router from 'src/routes/router';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';

import { CssBaseline } from '@mui/material';
import { Toaster } from 'react-hot-toast'; // Import Toaster
import ThemeProvider from './theme/ThemeProvider';
import { useDispatch } from 'react-redux';
import { setLoginStateFromStorage } from './store/reducer/auth.reducer';
import { refreshTokenThunk } from './store/action/auth.action';
import { AppDispatch } from './store/store';


function App() {
  const content = useRoutes(router);
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('userToken');
    const refreshToken = localStorage.getItem('refreshToken');

    if (token) {
      dispatch(setLoginStateFromStorage(token));

      if (refreshToken) {
        dispatch(refreshTokenThunk(refreshToken));
      }
    }
  }, [dispatch]);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        <Toaster />
        {content}
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;

